export default "__VITE_ASSET__BpIydNLO__"